import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import './MainTabs.module.scss';
import TabYaxDevices from './Tabs/TabYaxDevices/TabYaxDevices';
import ImportantDevicesIcon from '@mui/icons-material/ImportantDevices';
import LanguageIcon from '@mui/icons-material/Language';
import TabConnections from './Tabs/TabConnections/TabConnections';
import SourceOutlinedIcon from '@mui/icons-material/SourceOutlined';
import TabVersions from './Tabs/TabVersions/TabVersions';

const MainTabs = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="maintabs"
      hidden={value !== index}
      id={`vertical-maintabs-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

MainTabs.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

export default function VerticalTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box
      className={styles["maintabs"]}
      sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex' }}
    >
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={value}
        onChange={handleChange}
        sx={{ borderRight: 1, borderColor: 'divider' }}
      >
        <Tab label={i18n.t("devices")} {...a11yProps(0)} icon={<ImportantDevicesIcon />} />
        <Tab label={i18n.t("connections")} {...a11yProps(1)} icon={<LanguageIcon />} />
        <Tab label={i18n.t("versions")} {...a11yProps(2)} icon={<SourceOutlinedIcon />} />
      </Tabs>
      <MainTabs value={value} index={0}>
        <TabYaxDevices />
      </MainTabs>
      <MainTabs value={value} index={1}>
        <TabConnections />
      </MainTabs>
      <MainTabs value={value} index={2}>
        <TabVersions />
      </MainTabs>
    </Box>
  );
}

